import { Controller } from '@hotwired/stimulus'
import { renderReactComponent, unmountReactComponent } from '../helpers/react-component-renderer'

export default class extends Controller {
  static targets = ['showView', 'editView', 'editButton', 'cancelButton']
  static values = {
    clientId: String,
  }

  connect() {
    this.isEditing = false
  }

  startEdit() {
    this.showViewTarget.classList.add('hidden')
    this.editViewTarget.classList.remove('hidden')

    if (this.hasEditButtonTarget) {
      this.editButtonTarget.classList.add('hidden')
    }
    if (this.hasCancelButtonTarget) {
      this.cancelButtonTarget.classList.remove('hidden')
    }

    renderReactComponent({
      container: this.editViewTarget,
      componentName: 'components/insurance-edit-form',
      props: {
        clientId: this.clientIdValue,
      },
      callbacks: {
        onComplete: {
          controller: 'insurance-edit',
          function: 'handleComplete',
        },
      },
    })

    this.isEditing = true
  }

  cancelEdit() {
    unmountReactComponent(this.editViewTarget)

    this.editViewTarget.classList.add('hidden')
    this.showViewTarget.classList.remove('hidden')

    if (this.hasEditButtonTarget) {
      this.editButtonTarget.classList.remove('hidden')
    }
    if (this.hasCancelButtonTarget) {
      this.cancelButtonTarget.classList.add('hidden')
    }

    this.isEditing = false
  }

  handleComplete() {
    unmountReactComponent(this.editViewTarget)

    const turboFrame = this.element.closest('turbo-frame')
    if (turboFrame) {
      turboFrame.reload()
    }

    this.editViewTarget.classList.add('hidden')
    this.showViewTarget.classList.remove('hidden')

    if (this.hasEditButtonTarget) {
      this.editButtonTarget.classList.remove('hidden')
    }
    if (this.hasCancelButtonTarget) {
      this.cancelButtonTarget.classList.add('hidden')
    }

    this.isEditing = false
  }

  disconnect() {
    if (this.isEditing) {
      unmountReactComponent(this.editViewTarget)
    }
  }
}
